/* BAUTUMN Theme JavaScript */
(function () {
  'use strict';

  // ===== Mobile nav toggle =====
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mobile-nav-open]');
    var closeBtn = e.target.closest('[data-mobile-nav-close]');
    var menu = document.getElementById('MobileNav');
    if (!menu) return;
    if (openBtn) { menu.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (closeBtn) { menu.classList.remove('open'); document.body.style.overflow = ''; }
  });

  // ===== Accordion =====
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var accordion = trigger.closest('.accordion');
    if (!accordion) return;
    var open = accordion.classList.toggle('open');
    trigger.setAttribute('aria-expanded', open);
  });

  // ===== Fade-in scroll reveal (legacy .fade-in) =====
  if ('IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.fade-in').forEach(function (el) { fadeObserver.observe(el); });
  } else {
    document.querySelectorAll('.fade-in').forEach(function (el) { el.classList.add('visible'); });
  }

  // ===== Hero slideshow =====
  (function () {
    var hero = document.querySelector('[data-hero-slideshow]');
    if (!hero) return;
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dot');
    if (slides.length <= 1) return;
    var i = 0;
    function show(idx) {
      slides.forEach(function (s, n) { s.classList.toggle('active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('active', n === idx); });
      i = idx;
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    setInterval(function () { show((i + 1) % slides.length); }, 6000);
  })();

  // ===== Product gallery thumbs =====
  (function () {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('.product-gallery__main img');
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-image');
        if (main && src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  })();

  // ===== Stat counter animation =====
  (function () {
    var statsGrid = document.querySelector('.about-section__stats');
    if (!statsGrid || !window.IntersectionObserver) return;
    var statItems = statsGrid.querySelectorAll('.about-stat');
    var counters = statsGrid.querySelectorAll('[data-count-to]');
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmt(n, format) {
      n = Math.round(n);
      return format === 'comma' ? n.toLocaleString('en-US') : String(n);
    }
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    counters.forEach(function (el) {
      if (prefersReduced) return;
      var from = parseFloat(el.getAttribute('data-count-from') || '0');
      var suffix = el.getAttribute('data-count-suffix') || '';
      var prefix = el.getAttribute('data-count-prefix') || '';
      var format = el.getAttribute('data-count-format') || '';
      el.textContent = prefix + fmt(from, format) + suffix;
    });

    function animate(el) {
      var to = parseFloat(el.getAttribute('data-count-to'));
      var from = parseFloat(el.getAttribute('data-count-from') || '0');
      var duration = parseInt(el.getAttribute('data-count-duration') || '1600', 10);
      var suffix = el.getAttribute('data-count-suffix') || '';
      var prefix = el.getAttribute('data-count-prefix') || '';
      var format = el.getAttribute('data-count-format') || '';
      if (prefersReduced) { el.textContent = prefix + fmt(to, format) + suffix; return; }
      var start = performance.now();
      function tick(now) {
        var t = Math.min(1, (now - start) / duration);
        el.textContent = prefix + fmt(from + (to - from) * easeOutCubic(t), format) + suffix;
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = prefix + fmt(to, format) + suffix;
      }
      requestAnimationFrame(tick);
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          statItems.forEach(function (item) { item.classList.add('stat-animate'); });
          counters.forEach(animate);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    obs.observe(statsGrid);
  })();

  // ===== Variant selector =====
  (function () {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var select = form.querySelector('#VariantSelect');
    if (!select) return;
    var variantLabel = document.getElementById('variantLabel');
    var cartPrice = document.getElementById('cartPrice');
    var optionGroups = form.querySelectorAll('.variant-options');
    var selectedOptions = [];
    optionGroups.forEach(function (group, idx) {
      var active = group.querySelector('.variant-option.active');
      selectedOptions[idx] = active ? active.getAttribute('data-value') : null;
      group.querySelectorAll('.variant-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.variant-option').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selectedOptions[idx] = btn.getAttribute('data-value');
          updateVariant();
        });
      });
    });
    function updateVariant() {
      var target = selectedOptions.join(' / ');
      var found = false;
      Array.from(select.options).forEach(function (opt) {
        if (opt.getAttribute('data-title') === target) {
          opt.selected = true;
          found = true;
          if (variantLabel) variantLabel.textContent = opt.getAttribute('data-title');
          if (cartPrice) cartPrice.textContent = opt.getAttribute('data-price');
        }
      });
      if (!found && selectedOptions.length === 1) {
        Array.from(select.options).forEach(function (opt) {
          if (opt.getAttribute('data-title') === selectedOptions[0]) {
            opt.selected = true;
            if (variantLabel) variantLabel.textContent = opt.getAttribute('data-title');
            if (cartPrice) cartPrice.textContent = opt.getAttribute('data-price');
          }
        });
      }
    }
  })();

  // ===== Framer-style scroll reveal engine (staggered, directional) =====
  (function () {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          el.style.transitionDelay = (delay * 110) + 'ms';
          el.classList.add('is-revealed');
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  })();

  // ===== Hero parallax + subtle media drift =====
  (function () {
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    var heroMedia = document.querySelectorAll('[data-parallax-hero]');
    var driftMedia = document.querySelectorAll('[data-parallax-img]');
    if (!heroMedia.length && !driftMedia.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        heroMedia.forEach(function (m) {
          m.style.transform = 'translate3d(0,' + (y * 0.18) + 'px,0) scale(1.06)';
        });
        driftMedia.forEach(function (m) {
          var rect = m.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var progress = (rect.top - vh) / (rect.height + vh);
          var shift = Math.max(-1, Math.min(1, progress)) * 14;
          var img = m.querySelector('img');
          if (img) img.style.transform = 'translate3d(0,' + (-shift) + 'px,0) scale(1.08)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
})();
